<p-toast position="top-right" key="irias-toast"
		 [baseZIndex]="12000"
		 [preventOpenDuplicates]="false">
	<ng-template let-message pTemplate="message">
		<div class="">
			<h1 class="p-mt-1 p-mr-6">{{message.summary}}</h1>
			<p class="p-mt-0">{{message.detail}}</p>
		</div>
	</ng-template>
</p-toast>

<base-app-loader></base-app-loader>

<div class="page">
	<div class="p-grid p-d-print-none p-nogutter top-menu" *ngIf="!global.hideAll">
		<div class="p-col-fixed" style="width:264px">
			<div class="p-d-flex dova-brand">
				<a class="p-pl-3" routerLink="/projects">Dova Flextool</a>
			</div>
		</div>
		<div class="p-col">
			<p-toolbar styleClass="p-p-0">
				<div class="p-toolbar-group-left p-unselectable-text">

					<button pButton pRipple
							  class="p-button-rounded p-button-secondary p-button-text"
							  (click)="global.menu = !global.menu;"
							  [icon]="global.menu ? 'far fa-chevron-left' : 'far fa-chevron-right'">
					</button>
				</div>
				<div class="p-toolbar-group-right p-pr-3">
					<ng-container *ngIf="global.loginUser">
						<div class="profile-dropdown" (click)="userMenu.toggle($event)">
							<label class="p-unselectable-text p-pr-2">{{global.loginUser.email}}</label>
							<i class="far fa-user-shield"></i>
						</div>

						<p-menu #userMenu [style]="{'width': '16rem'}" [popup]="true" [model]="accountItems"></p-menu>
					</ng-container>
				</div>
			</p-toolbar>

		</div>
	</div>

	<div class="p-grid p-nogutter">
		<ng-container *ngIf="!global.hideAll && reloaded">
			<div class="p-col-fixed p-d-print-none" [ngClass]="{'hide-menu' : !global.menu}"
				 style="width:264px; max-height: calc(100vh - 56px); overflow-y: auto;">
				<p-panelMenu [model]="items" [styleClass]="'main-menu'"></p-panelMenu>
			</div>
		</ng-container>
		<div class="p-col" [ngStyle]="!global.hideAll && {'max-height': 'calc(100vh - 56px)', 'overflow-y': 'auto'}">
			<router-outlet></router-outlet>
		</div>
	</div>

</div>


<!-- MODALS -->

<p-dialog [visible]="global.loginModal"
		  [baseZIndex]="1500"
		  styleClass="irias-login-dialog"
		  maskStyleClass="irias-backdrop"
		  [showHeader]="true"
		  header="Login Flextool"
		  [style]="{'width':'480px'}"
		  [draggable]="false"
		  [closeOnEscape]="false"
		  [closable]="false"
		  [autoZIndex]="true"
		  [modal]="true"
		  [blockScroll]="true">
	<base-login *ngIf="global.loginModal"></base-login>
</p-dialog>

<p-dialog [(visible)]="showHelpDialog"
		  [style]="{'width': '30rem'}"
		  [baseZIndex]="1400"
		  header="Contactinfo Irias"
		  styleClass=""
		  [showHeader]="true"
		  [draggable]="true"
		  [closeOnEscape]="true"
		  [closable]="true"
		  [autoZIndex]="true"
		  [modal]="true"
		  [blockScroll]="true">

	<p class="p-mt-0">
		Heeft u vragen of opmerkingen, dan kunt u contact opnemen via <strong>info@irias.nl</strong> of via <strong>038 737 02 91</strong> (maandag – vrijdag, 8.00 – 17.00 uur).

		Irias Informatiemanagement is u graag van dienst.
	</p>

	<p class="p-mt-4">
		Heeft u vragen betreft de werking van de tool, dan kunt ook onze handleiding downloaden.
	</p>

	<a pButton pRipple type="button"
	   class="p-button-rounded"
	   icon="pi pi-download"
	   label="Download handleiding"
	   [style]="{'text-decoration': 'auto'}"
	   [href]="manualUrl"></a>

	<ng-template pTemplate="footer">
		<div class="p-d-flex">
			<div class="p-ml-auto">
				<button pButton pRipple type="button" (click)="showHelpDialog = false;"
						label="Sluiten"
						class="p-button-secondary p-button-text p-button-rounded"></button>
			</div>
		</div>
	</ng-template>
</p-dialog>

<p-confirmDialog
	[closeOnEscape]="false"
	styleClass="agreeDialog"
	key="agreementDialog"
	maskStyleClass="irias-backdrop"
	[style]="{width: '30rem'}"
	[baseZIndex]="10000">
</p-confirmDialog>

<p-dialog [(visible)]="showUserPrefsDialog"
		  [style]="{'width': '45rem'}"
		  [baseZIndex]="1400"
		  header="Algemene voorkeuren"
		  styleClass=""
		  [showHeader]="true"
		  [draggable]="true"
		  [closeOnEscape]="true"
		  [closable]="true"
		  [autoZIndex]="true"
		  [modal]="true"
		  [blockScroll]="true">

	<h2>Persoonlijke instellingen</h2>
	<div class="p-field-checkbox">
		<p-checkbox name="mail" [(ngModel)]="userPrefs.send_kpi_email" [binary]="true" inputId="mail"></p-checkbox>
		<label [for]="'mail'">Maandelijks een kpi-rapportage ontvangen per e-mail</label>
	</div>

	<ng-template pTemplate="footer">
		<div class="p-d-flex p-ai-center p-pt-5">
			<button pButton pRipple type="button" label="Sluiten"
					class="p-button-secondary p-button-text p-button-rounded p-mr-2 p-ml-auto"
					(click)="showUserPrefsDialog = false;"></button>
			<button pButton pRipple type="button" label="Opslaan" class="p-button-rounded p-text-uppercase"
					(click)="setUserPrefs()"></button>
		</div>
	</ng-template>
</p-dialog>
